import dynamic from 'next/dynamic';

const AgentsPage = dynamic(() => import('sly/agentsPage'));

export const getServerSideProps = () => ({ props: {} });

export default AgentsPage;
